import { StatusBar } from 'react-native';
import { NavigationContainer } from './NavigationContainer';
import EpaAuthProvider from '../containers/EpaAuthContextProvider';

import { isPatientApp } from '@/config/constants';
import { usePrivacy } from '@/hooks/usePrivacy';

import { DialogProvider } from '@/components/ui/shared/Dialog';

import { AnonymousStack } from './AnonymousStack';
import { PatientStack } from './PatientStack';
import { TherapistStack } from './TherapistStack';
import { useStoreState } from '@/stores/store';

function ActiveStack() {
  const { isAuthenticated } = useStoreState((store) => ({
    isAuthenticated: store.isAuthenticated,
  }));

  usePrivacy(isAuthenticated);

  return (
    <>
      {isAuthenticated && isPatientApp && <PatientStack />}
      {isAuthenticated && !isPatientApp && <TherapistStack />}
      {!isAuthenticated && <AnonymousStack />}
    </>
  );
}

export function AppNavigation() {
  return (
    <NavigationContainer>
      <StatusBar hidden={true} translucent={true} />
      <DialogProvider>
        <EpaAuthProvider>
          <ActiveStack />
        </EpaAuthProvider>
      </DialogProvider>
    </NavigationContainer>
  );
}
